export default __webpack_public_path__ + "static/media/Bezel_Black_Green.700ba747.png";